var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.516 8.016c4.125 0 7.734 2.39 9.422 5.906.328.656-.047 1.5-.75 1.734-.563.188-1.22-.094-1.5-.656-1.266-2.672-4.032-4.5-7.172-4.5-1.97 0-3.75.703-5.11 1.875l1.875 1.922c.656.61.188 1.687-.703 1.687H3A.96.96 0 0 1 2.016 15V9.422c0-.89 1.078-1.36 1.687-.703l1.875 1.875C7.453 9 9.844 8.016 12.516 8.016"
  })));
};
export default SvgUndo;